import React from 'react';
import PropTypes from 'prop-types';
import css from './SignIn.css';
import KioskImage from './KioskImage';
import ReadMoreLessText from '../common/ReadMoreLessText';
import ProspectiveSignInForm from './ProspectiveSignInForm';
import TextHeader from "./TextHeader";

function ProspectiveSignIn(props) {
  return (
    <div>
      <header className={css['header']}>
        <KioskImage name={props.kioskName} imageUrl={props.kioskImageUrl} />
        <div className={css['kiosk-name']}>{props.kioskName}</div>
      </header>
      <div className={css['content']}>
        <TextHeader
          upperText={props.greetingText}
          lowerText={props.mainHeader}
        />
        <div className={css['instructions']}>
          <ReadMoreLessText text={props.instructionsText} />
        </div>
        <ProspectiveSignInForm
          setError={props.setError}
          onSignIn={props.onSignIn}
          kioskId={props.kioskId}
          kioskUid={props.kioskUid}
          contentRef={props.contentRef}
        />
      </div>
    </div>
  );
}

ProspectiveSignIn.propTypes = {
  kioskId: PropTypes.number.isRequired,
  kioskUid: PropTypes.string.isRequired,
  kioskName: PropTypes.string.isRequired,
  kioskImageUrl: PropTypes.string.isRequired,
  onSignIn: PropTypes.func.isRequired,
  setError: PropTypes.func.isRequired,
  greetingText: PropTypes.string,
  mainHeader: PropTypes.string,
  instructionsText: PropTypes.string,
  contentRef: PropTypes.object.isRequired,
};

export default ProspectiveSignIn;
